const city = {
    namespaced: true,
    state: {
        list: [],
        totalCount: 0,
        pageSize: 10,
        currentPage: 1,
        cityInfo: {},
        cityList: []
    },
    mutations: {
        setPageSize(state, size) {
            state.pageSize = size;
        },
        setCurrentPage(state, page) {
            state.currentPage = page;
        }
    },
    actions: {
        async getAll({ state }, payload) {
            let page = {
                name: payload.data.name,
                maxResultCount: state.pageSize,
                skipCount: (state.currentPage - 1) * state.pageSize
            };
            let rep = await abp.ajax.post('/api/services/app/City/SearchCities', page);
            state.list = [];
            state.list.push(...rep.data.result.items);
            state.totalCount = rep.data.result.totalCount;
        },
        async GetCityById({ state }, payload) {
            let rep = await abp.ajax.get('/api/services/app/City/GetCityById?id=' + payload.id);
            state.cityInfo = {};
            state.cityInfo = rep.data.result;
        },
        async delCity({ state }, payload) {
            await abp.ajax.delete('/api/services/app/City/DeleteCityById?id=' + payload.id);
        },
        async saveCity({ state }, payload) {
            await abp.ajax.post('/api/services/app/City/SaveCity', payload.data);
        },
        async getCityList({ state }, payload) {
            let rep = await abp.ajax.get('/api/services/app/City/GetCityList');
            state.cityList = [];
            state.cityList.push(...rep.data.result.items);
        }
    }
};
export default city;
